/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesCase from "../../Stages/StagesCase";
import { abstractLitigationCaseRequiredFields } from "../AbstractLitigationCase/abstractLitigationCaseRequiredFields";
import { DataLeakContract } from "../../../types/Products/ContractLaw/DataLeakContract";

export const dataLeakRequiredFields = {
  ...abstractLitigationCaseRequiredFields,
  [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: (dataLeakCase: DataLeakContract) => {
    let requiredFields = abstractLitigationCaseRequiredFields[stagesCase.STAGE_DATA_COMPLETED_LAWFIRM](dataLeakCase);
    requiredFields.push("objectiveLawFirm");
    return requiredFields;
  },
  [stagesCase.STAGE_PREPARE_LAWSUIT]: (dataLeakCase: DataLeakContract) => {
    let requiredFields = abstractLitigationCaseRequiredFields[stagesCase.STAGE_PREPARE_LAWSUIT](dataLeakCase);
    requiredFields.push("personalAffection.personalAffectionLawFirm");

    return requiredFields;
  },
};
